import { memo, useMemo } from "react";

import ChatDrawer from "../ChatDrawer";

import { useMosaicChat } from "./useMosaicChat";
import { useSelectedProject } from "modules/projects/hooks/useSelectedProject";

import { MosaicChatAgent } from "modules/chat/types/entities";

const emptyViewMap: Record<
  MosaicChatAgent,
  {
    title: string;
    description: string;
    context?: string[] | undefined;
    suggestedMessages?: string[] | undefined;
  }
> = {
  "brainstorm-synthesis": {
    title: "Brainstorm Synthesis",
    description: "Ask Mosaic to synthesize the brainstorming idea"
  },
  mosaic: {
    title: "Ask Mosaic",
    description: "Ask Mosaic any question about the project",
    suggestedMessages: [
      "What have we learned about user retention this quarter?",
      "How checkout conversion rate has changed over time since last year?",
      "Help me draft new brainstorming ideas for bounce rate optimization",
      "What are the most important metrics to track for user retention?"
    ]
  }
};

type MosaicChatProps = {
  trigger: React.ReactNode;
};
const MosaicChat = (props: MosaicChatProps) => {
  const { trigger } = props;

  const { threadId, agentId, canOpenChat, closeChat } = useMosaicChat();

  const { rollupProjects } = useSelectedProject();

  const emptyView = useMemo(() => {
    if (agentId) {
      return emptyViewMap[agentId];
    }
  }, [agentId]);

  const initialProjectIds = useMemo(() => {
    return rollupProjects.map(project => project.id);
  }, [rollupProjects]);

  return (
    <>
      {canOpenChat ? trigger : null}

      {threadId && agentId ? (
        <ChatDrawer
          threadId={threadId}
          agentId={agentId}
          onClose={closeChat}
          initialProjectIds={initialProjectIds}
          emptyView={emptyView}
        />
      ) : null}
    </>
  );
};

export default memo(MosaicChat);
